import { getHolidayId } from './config_holidays';
import { getWeekendId } from './config_weekend';

const hours = {
    lang_fi: {
        normal: '08:00',
        fri_sat: '08:00',
        sat_sun: '08:00',
    },
    lang_se: {
        normal: '08:00',
        fri_sat: '08:00',
        sat_sun: '08:00',
    },
    lang_no: {
        normal: '09:00',
        fri_sat: '09:00',
        sat_sun: '12:00',
    },
    lang_dk: {
        normal: '08:00',
        fri_sat: '10:00',
        sat_sun: '10:00',
    },
    lang_en: {
        normal: '08:00',
        fri_sat: '08:00',
        sat_sun: '08:00',
    },
};

// getOpeningHour :: string => string
export const getOpeningHours = (language) => {
    const now = new Date();
    const activeId = [getHolidayId(language, now), getWeekendId(language, now)].reduce((id1, id2) =>
        id1 === 'normal' ? id2 : id1
    );
    return hours[activeId];
};
